(() => {
  function init(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    const slides = [...root.querySelectorAll('[data-lucent-slide]')];
    const dots = [...root.querySelectorAll('[data-carousel-dot]')];
    const controls = root.querySelector('.lucent-fall-carousel__controls');
    const pause = root.querySelector('[data-carousel-pause]');
    const status = root.querySelector('.lucent-fall-carousel__status');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let timer;
    let playing = root.dataset.autoplay === 'true' && !reduced.matches;
    let hovered = false;
    let touchStart;
    function schedule() {
      clearTimeout(timer);
      if (playing && !hovered && !document.hidden && !root.contains(document.activeElement) && root.isConnected) {
        timer = setTimeout(() => { show((index + 1) % slides.length); }, 4000);
      }
    }
    function show(next, manual = false) {
      index = (next + slides.length) % slides.length;
      root.dataset.activeSlide = String(index);
      slides.forEach((slide, i) => {
        slide.hidden = false;
        slide.setAttribute('aria-hidden', String(i !== index));
        slide.inert = i !== index;
      });
      dots.forEach((dot, i) => { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      if (manual) status.textContent = slides[index].getAttribute('aria-label');
      const img = slides[index].querySelector('img');
      if (img) img.loading = 'eager';
      schedule();
    }
    function updatePause() {
      pause.setAttribute('aria-label', playing ? pause.dataset.pauseLabel : pause.dataset.playLabel);
      pause.firstElementChild.textContent = playing ? 'Ⅱ' : '▷';
    }
    function manual(next) { playing = false; updatePause(); show(next, true); }
    root.querySelector('[data-carousel-prev]').addEventListener('click', () => manual(index - 1));
    root.querySelector('[data-carousel-next]').addEventListener('click', () => manual(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => manual(i)));
    pause.addEventListener('click', () => { playing = !playing; updatePause(); schedule(); });
    root.addEventListener('mouseenter', () => { hovered = true; schedule(); });
    root.addEventListener('mouseleave', () => { hovered = false; schedule(); });
    root.addEventListener('focusin', () => clearTimeout(timer));
    root.addEventListener('focusout', () => setTimeout(schedule, 0));
    document.addEventListener('visibilitychange', schedule);
    reduced.addEventListener('change', () => { if (reduced.matches) playing = false; updatePause(); schedule(); });
    root.querySelector('.lucent-fall-carousel__track').addEventListener('touchstart', e => { touchStart = [e.changedTouches[0].clientX, e.changedTouches[0].clientY]; }, {passive:true});
    root.querySelector('.lucent-fall-carousel__track').addEventListener('touchend', e => {
      if (!touchStart) return;
      const dx = e.changedTouches[0].clientX - touchStart[0];
      const dy = e.changedTouches[0].clientY - touchStart[1];
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) manual(index + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, {passive:true});
    slides.forEach(slide => { const img = slide.querySelector('img'); if (img) img.loading = 'eager'; });
    controls.hidden = false;
    updatePause();
    show(0);
  }
  document.querySelectorAll('[data-lucent-carousel]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-lucent-carousel]').forEach(init));
})();
